export const feedbackConstants = {
    //send feedback
    FEEDBACK_REQUEST: 'FEEDBACK_REQUEST',
    FEEDBACK_SUCCESS: 'FEEDBACK_SUCCESS',
    FEEDBACK_FAILURE: 'FEEDBACK_FAILURE',
};